import MashRankLogo from "../components/MashRankLogo/MashRankLogo";
import Navbar from "../components/Navbar/Navbar";
import style from "./Layout.module.css";
import { Link } from "react-router-dom";

export default function Layout({ children }: { children: any }) {
  return (
    <div className={style.container}>
      <header className={style.header}>
        <Link to="/" className={style.logoLink}>
          <MashRankLogo height={100} />
        </Link>
        <div className={style.navbar}>
          <Navbar />
        </div>
      </header>
      <div className={style.body}>
        <main className={style.main}>{children}</main>
      </div>
    </div>
  );
}
